import PathJobResumeDetailDto from "./PathJobResumeDetailDto";

export default class PathJobResumeGroupDto {
    Label: string;
    Count: number;
    Details: PathJobResumeDetailDto[];

    constructor(
        label: string,
        count: number,
        details: PathJobResumeDetailDto[]
    ) {
        this.Label = label;
        this.Count = count;
        this.Details = details;
    }
}